// import React from 'react';
import SurveyDatumItem from "../Domain/SurveyDatumItem.js";
import serviceHelper from "../Helpers/serviceHelper.js";
import AuthService from "./authService.js";
import SearchParams from '../Elements/SearchParams';
import SurveySearchParams from '../Contents/RoverImport/Survey/SurveySearchParams';

class SurveyDatumService /*extends React.Component*/ {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(searchItem, SurveySearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/SurveyDatum/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map(item => new SurveyDatumItem(item));
    }

    return mappedItems;
  }

  static EditSurveyDatum(surveyDatum) {
    surveyDatum = serviceHelper.ConvertAllPropertyToString(surveyDatum);
    let surveyDatumJSON = JSON.stringify(surveyDatum);

    return AuthService.getInstance().CallBackendFunctionPut("/api/SurveyDatum/EditSurveyDatum", surveyDatumJSON);
  }
}

export default SurveyDatumService;
